import {
  Component,
  OnInit,
  ViewChildren,
  QueryList,
  Input,
  OnChanges,
  Output,
  EventEmitter,
} from '@angular/core';
import {
  NgbdSortableHeader,
  SortEvent,
} from 'src/app/directives/sortable/sortable.directive';

import { Product } from 'src/app/core/classes/product';
import { ProductService } from 'src/app/core/services/product.services';
import { Brand } from 'src/app/core/classes/brand';
import { Subbrand } from 'src/app/core/classes/subbrand';
import { Format } from 'src/app/core/classes/format';
import { Line } from 'src/app/core/classes/line';
import { ProductFilter } from 'src/app/core/classes/productFilter';

@Component({
  selector: 'dq-pos-products',
  templateUrl: './pos-products.component.html',
  styleUrls: ['./pos-products.component.scss'],
})
export class PosProductsComponent implements OnInit, OnChanges {
  constructor(private productService: ProductService) {
    this.refreshProducts();
  }

  total: number = 0;
  page = 1;
  pageSize = 10;

  @Input()
  products: Product[] | null = [];

  @Input()
  brands: Brand[] | null = [];

  @Input()
  lines: Line[] | null = [];

  @Input()
  subbrands: Subbrand[] | null = [];

  @Input()
  formats: Format[] | null = [];

  @Output() sort = new EventEmitter<SortEvent>();

  @Output() filterChange = new EventEmitter<ProductFilter>();

  productsPaginated: Product[] = [];

  filter_selection: ProductFilter = new ProductFilter();
  last_filter_selection: ProductFilter = new ProductFilter();

  ngOnInit(): void {
    this.refreshProducts();
  }
  ngOnChanges(): void {
    this.refreshProducts();
  }

  color(product: Product): string {
    let color = 'success';
    let numMonths = this.monthDiff(
      new Date(product.lastPurchasedate),
      new Date()
    );
    if (numMonths <= 2) {
      color = 'success';
    } else if (numMonths <= 4) {
      color = 'warning';
    } else {
      color = 'danger';
    }
    return color;
  }

  onSort({ column, direction }: SortEvent) {
    this.sort.emit({ column: column, direction: direction });
  }

  monthDiff(dateFrom: Date, dateTo: Date): number {
    return (
      dateTo.getMonth() -
      dateFrom.getMonth() +
      12 * (dateTo.getFullYear() - dateFrom.getFullYear())
    );
  }

  refreshProducts() {
    if (this.products != null) {
      this.total = this.products.length;

      this.productsPaginated = this.products.slice(
        (this.page - 1) * this.pageSize,
        (this.page - 1) * this.pageSize + this.pageSize
      );
    }
  }

  changeBrand(item: any) {
    if (item) {
      this.filter_selection.brand = item.id;
      this.filter_selection.subbrand = '';
      this.filter_selection.line = '';
      this.filter_selection.format = '';
      this.emitFilterChange();
    }
  }
  unselectedBrand(event: any) {
    this.filter_selection.brand = '';
    this.filter_selection.subbrand = '';
    this.filter_selection.line = '';
    this.filter_selection.format = '';
    this.emitFilterChange();
  }

  changeSubBrand(item: any) {
    if (item) {
      this.filter_selection.subbrand = item.id;
      this.filter_selection.line = '';
      this.filter_selection.format = '';
      this.emitFilterChange();
    }
  }
  unselectedSubBrand(event: any) {
    this.filter_selection.subbrand = '';
    this.filter_selection.line = '';
    this.filter_selection.format = '';
    this.emitFilterChange();
  }

  changeLine(item: any) {
    if (item) {
      this.filter_selection.line = item.id;
      this.filter_selection.format = '';
      this.emitFilterChange();
    }
  }
  unselectedLine(event: any) {
    this.filter_selection.line = '';
    this.filter_selection.format = '';
    this.emitFilterChange();
  }
  changeFormat(item: any) {
    if (item) {
      this.filter_selection.format = item.id;
      this.emitFilterChange();
    }
  }
  unselectedFormat(event: any) {
    this.filter_selection.format = '';
    this.emitFilterChange();
  }

  emitFilterChange() {
    if (
      JSON.stringify(this.filter_selection) !==
      JSON.stringify(this.last_filter_selection)
    ) {
      this.last_filter_selection = Object.assign({}, this.filter_selection);
      this.filterChange.emit(this.filter_selection);
    }
  }
}
